/**
 * DealHealthBadge — ONE capsule for one server health signal (2.4, P2-12),
 * shared by the board card (worst signal, "+N" for the rest, uppercased to
 * match the card's other capsules) and Deal Detail (every signal, with its
 * `since` so a rep reads "stale since 29 Aug", not just a colour).
 *
 * Colour comes from healthTone(severity) — never from the code (H-2). An
 * unknown severity renders the outline capsule with no status colour.
 */
import type { DealHealthSignal } from '../../../../api/types'
import { fmtSince, healthTone } from './dealHealth'

export function DealHealthBadge({ signal, more = 0, since = false, upper = false }: {
  signal: DealHealthSignal
  /** How many further signals this one stands for on a one-badge surface. */
  more?: number
  /** Append " · since <date>" (Deal Detail). */
  since?: boolean
  /** Uppercase, for the board card's capsule row. */
  upper?: boolean
}) {
  const tone = healthTone(signal.severity)
  const sinceLabel = fmtSince(signal.since)
  const text = since && sinceLabel ? `${signal.label} · since ${sinceLabel}` : signal.label
  const suffix = more > 0 ? ` +${more}` : ''
  const title = `${signal.label}${sinceLabel ? ` — since ${sinceLabel}` : ''}${more > 0 ? ` (+${more} more)` : ''}`
  const cls = tone ? 'k-badge' : 'k-badge-outline text-ink-muted'
  return (
    <span className={`${cls}${upper ? ' uppercase' : ''}`} style={tone ?? undefined} title={title}
      data-code={signal.code} data-severity={signal.severity}>
      <span className="k-badge-dot" />{text}{suffix}
    </span>
  )
}
